/**
 * Раздел «verify»: диалог проверки пакета розыгрыша (ui/VerifyDialog.tsx, lib/verification.ts).
 * Ключи 'check.<код>' — шаблоны результатов проверок; русские берутся из каталога
 * @mt/verification (packages/verification/src/messages.ts), en и de переводят те же коды.
 */
import { VERIFY_MESSAGES_RU, type VerifyCode } from '@mt/verification';

/** Шаблоны проверок с префиксом 'check.' — ключи словаря. */
const checks = Object.fromEntries(Object.entries(VERIFY_MESSAGES_RU).map(([k, v]) => [`check.${k}`, v])) as { [K in VerifyCode as `check.${K}`]: string };

export const verify = {
  title: 'Проверка розыгрыша',
  chooseFile: 'Выбрать файл пакета…',
  hintBefore: 'Проверка выполняется в вашем браузере тем же открытым кодом, что и консольная утилита ',
  hintAfter: '. Сервер в ней не участвует, кроме выдачи своего открытого ключа.',
  notJson: 'Файл не является JSON-пакетом проверки',
  httpError: 'ошибка {status}',
  metaGame: 'Розыгрыш',
  metaComposition: 'Состав',
  metaP0: 'Бар P₀ (UTC)',
  metaSource: 'Источник',
  sourceSynthetic: 'синтетические данные — не реальные котировки',
  sourceAlpaca: 'Alpaca Market Data API v2, минутные бары, поток {feed}',
  busy: 'Пересчёт…',
  exportHint: 'Выгрузки для сравнения с внешними источниками котировок (UTC, разделитель «;»):',
  exportQuotes: 'Котировки акций, CSV',
  exportIndex: 'Бары индекса, CSV',
  exportActions: 'Журнал ходов, CSV',
  exportPackage: 'Пакет, JSON',
  ...checks,
};
